import { jsx as _jsx } from "react/jsx-runtime";
import { BreadcrumbsBase } from '@/shared/components';
const Breadcrumbs = (props) => {
    return _jsx(BreadcrumbsBase, { ...props });
};
export { Breadcrumbs };
